(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["domain-migration-popup"]) return;
  try {
    
  class DomainMigrationPopup extends HTMLElement {
    #abortController = null;
    #cartNoteSync = null;
    #dialog = null;
    #returnFocusElement = null;

    connectedCallback() {
      if (this.#abortController) return;

      this.#dialog = this.querySelector('dialog');
      this.#abortController = new AbortController();

      if (this.#isCartSyncEligible()) void this.#syncCartNote();

      if (!this.#dialog) return;

      this.#bindEvents();

      if (!this.#shouldOpen()) return;

      window.requestAnimationFrame(() => this.#open());
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      this.#abortController = null;
      this.#unlockPage();
    }

    #bindEvents() {
      const signal = this.#abortController.signal;

      for (const closeControl of this.querySelectorAll('[data-migration-popup-close]')) {
        closeControl.addEventListener('click', () => this.#close(), { signal });
      }

      this.#dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.#close();
      }, { signal });
      this.#dialog.addEventListener('close', () => this.#afterClose(), { signal });
      this.#dialog.addEventListener('click', (event) => {
        if (event.target === this.#dialog) this.#close();
      }, { signal });
      this.#dialog.addEventListener('keydown', (event) => this.#trapFocus(event), { signal });
    }

    #shouldOpen() {
      if (this.dataset.enabled !== 'true') return false;
      if (typeof this.#dialog.showModal !== 'function') return false;
      if (this.dataset.pageType !== 'collection') return false;
      if (this.#isDesignMode()) return true;
      if (!this.#hasMigrationSignature()) return false;
      if (!this.#hasCollectionPopupMarker()) return false;

      return !this.#wasShownThisSession();
    }

    #isCartSyncEligible() {
      return (
        this.dataset.enabled === 'true' &&
        !this.#isDesignMode() &&
        this.#hasMigrationSignature()
      );
    }

    #hasMigrationSignature() {
      const url = new URL(window.location.href);
      const requiredParameters = {
        utm_source: 'theeyebar_redirect',
        utm_medium: '301',
        utm_campaign: 'domain_migration'
      };

      return Object.entries(requiredParameters).every(([name, value]) => {
        const values = url.searchParams.getAll(name);
        return values.length === 1 && values[0] === value;
      });
    }

    #hasCollectionPopupMarker() {
      const url = new URL(window.location.href);

      return (
        this.#hasExactQueryParameter(
          url,
          this.dataset.popupQueryParameter,
          this.dataset.popupQueryValue
        ) ||
        this.#hasExactQueryParameter(
          url,
          this.dataset.productUnavailableQueryParameter,
          this.dataset.productUnavailableQueryValue
        )
      );
    }

    #hasExactQueryParameter(url, parameter, value) {
      if (!parameter || !value) return false;

      const values = url.searchParams.getAll(parameter);

      return values.length === 1 && values[0] === value;
    }

    #syncCartNote() {
      if (this.#cartNoteSync) return this.#cartNoteSync;

      const cartUrl = this.dataset.cartUrl;
      const cartUpdateUrl = this.dataset.cartUpdateUrl;
      const marker = this.dataset.cartNoteMarker;

      if (!cartUrl || !cartUpdateUrl || !marker || typeof window.fetch !== 'function') {
        // Cart attribution is optional enhancement; the dialog must remain usable without it.
        return Promise.resolve();
      }

      this.#cartNoteSync = window.fetch(cartUrl, {
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then((response) => {
          if (!response.ok) throw new Error('Unable to read cart note.');

          return response.json();
        })
        .then((cart) => {
          const existingNote = cart?.note === null ? '' : cart?.note;
          if (typeof existingNote !== 'string') {
            throw new Error('Cart note is not a string.');
          }
          if (this.#hasCartNoteMarker(existingNote, marker)) return null;

          const note = existingNote === '' ? marker : `${existingNote}\n${marker}`;

          return window.fetch(cartUpdateUrl, {
            method: 'POST',
            credentials: 'same-origin',
            keepalive: true,
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ note })
          }).then((response) => {
            if (!response.ok) throw new Error('Unable to update cart note.');
          });
        })
        .catch(() => {
          // Cart API failures must never block a migration visitor's navigation or dialog controls.
          return null;
        });

      return this.#cartNoteSync;
    }

    #hasCartNoteMarker(note, marker) {
      const escapedMarker = marker.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const markerLine = new RegExp(`(?:^|\\r?\\n)${escapedMarker}(?=\\r?\\n|$)`);

      return markerLine.test(note);
    }

    #wasShownThisSession() {
      if (this.dataset.shown === 'true') return true;

      try {
        return window.sessionStorage.getItem(this.dataset.sessionKey) === 'shown';
      } catch {
        // Storage may be unavailable; the data attribute still protects this page view.
        return false;
      }
    }

    #markAsShown() {
      this.dataset.shown = 'true';

      try {
        window.sessionStorage.setItem(this.dataset.sessionKey, 'shown');
      } catch {
        // The in-page data attribute still prevents duplicate opening.
      }
    }

    #open() {
      if (!this.#dialog || this.#dialog.open) return;

      this.#returnFocusElement = document.activeElement;

      try {
        this.#dialog.showModal();
      } catch {
        // Never fall back to a non-modal state without native focus isolation.
        return;
      }

      if (!this.#isDesignMode()) this.#markAsShown();
      document.documentElement.classList.add('migration-popup-is-open');
      document.body.classList.add('migration-popup-is-open');
      this.#firstFocusableElement()?.focus({ preventScroll: true });
    }

    #close() {
      if (!this.#dialog?.open) return;

      this.#dialog.close();
    }

    #afterClose() {
      this.#unlockPage();

      if (
        this.#returnFocusElement instanceof HTMLElement &&
        this.#returnFocusElement.isConnected &&
        this.#returnFocusElement !== document.body
      ) {
        this.#returnFocusElement.focus({ preventScroll: true });
        return;
      }

      const mainContent = document.querySelector('main');
      if (!mainContent) return;

      const hadTabIndex = mainContent.hasAttribute('tabindex');
      if (!hadTabIndex) mainContent.setAttribute('tabindex', '-1');
      mainContent.focus({ preventScroll: true });
      if (!hadTabIndex) mainContent.addEventListener('blur', () => {
        mainContent.removeAttribute('tabindex');
      }, { once: true });
    }

    #unlockPage() {
      document.documentElement.classList.remove('migration-popup-is-open');
      document.body.classList.remove('migration-popup-is-open');
    }

    #trapFocus(event) {
      if (event.key !== 'Tab') return;

      const focusableElements = this.#focusableElements();
      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    #firstFocusableElement() {
      return this.#focusableElements()[0];
    }

    #focusableElements() {
      return Array.from(this.#dialog.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((element) => !element.hasAttribute('hidden'));
    }

    #isDesignMode() {
      return Boolean(window.Shopify?.designMode);
    }
  }

  if (!customElements.get('domain-migration-popup')) {
    customElements.define('domain-migration-popup', DomainMigrationPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
                    var loadProductRecommendationsIntoSection = function() {
                    // Look for an element with class 'product-recommendations'
                    var productRecommendationsSection = document.querySelector(".product-recommendations");
                    if (productRecommendationsSection === null) { return; }
                    // Read product id from data attribute
                    var productId = productRecommendationsSection.dataset.productId;
                    // Read limit from data attribute
                    var limit = productRecommendationsSection.dataset.limit;
                    // Build request URL
                    var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
                    // Create request and submit it using Ajax
                    var request = new XMLHttpRequest();
                    request.open("GET", requestUrl);
                    request.onload = function() {
                    if (request.status >= 200 && request.status < 300) {
                                                                      var container = document.createElement("div");
                                                                      container.innerHTML = request.response;
                                                                      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
                                                                      }
                                                                      };
                                                                      request.send();
                                                                      };
                                                                      // If your section has theme settings, the theme editor
                                                                      // reloads the section as you edit those settings. When that happens, the
                                                                      // recommendations need to be fetched again.
                                                                      // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
                                                                      document.addEventListener("shopify:section:load", function(event) {
                                                                      if (event.detail.sectionId === "product-recommendations") {
                                                                      loadProductRecommendationsIntoSection();
                                                                      }
                                                                      });
                                                                      // Fetching the recommendations on page load
                                                                      loadProductRecommendationsIntoSection();
                                                                      
  } catch(e) { console.error(e); }
})();
})();
